import styled from 'styled-components'
import { Card, CardContent } from '@mui/material'
import { GGBLogoWideDark, LoginBg } from 'assets/images'
import { Outlet } from 'react-router-dom'
import HeadHelmet from 'components/route/HeadHelmet'
import useRouteData from 'hooks/useRouteData'

export default function GuestAppContainer(): JSX.Element {
  const { titleId = '' } = useRouteData()

  return (
    <>
      <HeadHelmet titleId={titleId} />
      <PageContainer>
        <StyledCard>
          <LogoContainer>
            <Logo src={GGBLogoWideDark} alt="Login" />
          </LogoContainer>
          <StyledCardContent>
            <Outlet />
          </StyledCardContent>
        </StyledCard>
      </PageContainer>
    </>
  )
}

const PageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
  background-image: url(${LoginBg});
  background-size: cover;
  background-position: center center;
  padding: 60px 0 80px 0;

  @media (min-height: 900px) {
    padding: 0;
  }
`

const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  width: 474px;
  border-radius: 4px;
  padding: 30px 0;
  background-color: ${(props) => props.theme.palette.common.white};
  ${(props) => props.theme.breakpoints.down('xs')} {
    width: 100%;
    border-radius: 0;
  }
  margin-top: 120px;

  @media (min-height: 900px) {
    margin-top: 180px;
  }
`

const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 29px;
`

const Logo = styled.img`
  width: 280px;
`

const StyledCardContent = styled(CardContent)`
  padding: 0 64px;
  &:last-child {
    padding-bottom: 0;
  }
`
